export default {
  TNC_ERROR: 'Om in te loggen, moet u eerst de algemene voorwaarden en het privacybeleid van Fielddrive accepteren.',
  WELCOME_BACK: 'Setup voortzetten! Je bent succesvol ingelogd.',
  TNC_LABEL: 'door dit vakje aan te vinken gaat u akkoord met de Fielddrive Leads',
  TNC: 'Voorwaarden & Condities',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'en',
  POLICY: 'Privacybeleid',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'U geeft Fielddrive Leads toestemming om uw persoonsgegevens te verwerken voor de daarin aangegeven doeleinden.',
  LOGIN: 'Inloggen'
}
